import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';
import { useSelector, useDispatch } from 'react-redux';
import {
  LeaveContactsModal,
  TLeaveContactsModalOnSubmitParams,
  attemptToGetMessageFromUnknownError,
  formatPhone,
} from '@cian/frontend-e2e-deal-component';

import { useApplicationContext } from '../../utils/applicationContext';
import { selectIsModalOpen } from '../../selectors/consultationRequest';
import { setModalOpen } from '../../actions';
import { sendConsultationRequest } from '../../actions/consultationRequest/sendConsultationRequest';
import { TThunkDispatch } from '../../types/redux';
import { NBSP } from '../../constants/symbols';
import { trackConsultationRequestFormSubmit } from './tracking';

/**
 * Модалка с формой заявки "Хочу консультацию"
 */
export const ConsultationRequestModalContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const isModalOpen = useSelector(selectIsModalOpen);
  const dispatch = useDispatch<TThunkDispatch>();
  const deviceType = useDeviceType();

  const customerSupportPhone = formatPhone({
    phone: /* istanbul ignore next */ config.get<string>('e2e-deal-sale.customSupportContactPhone') || '',
  });

  const handleModalClose = () => dispatch(setModalOpen(false));
  const handleFormSubmit = async (params: TLeaveContactsModalOnSubmitParams) => {
    const result = await dispatch(sendConsultationRequest(params));
    const isError = 'error' in result;

    if (!isError) {
      trackConsultationRequestFormSubmit();
    }

    return {
      status: /* istanbul ignore next */ isError ? 'error' : 'success',
      errorMessage: attemptToGetMessageFromUnknownError(result.error),
    } as const;
  };

  return (
    <LeaveContactsModal
      isOpen={isModalOpen}
      onClose={handleModalClose}
      onSubmit={handleFormSubmit}
      texts={{
        title: (
          <>
            Позвоните на{' '}
            {
              /* istanbul ignore next */ deviceType === 'phone' ? (
                <a href={`tel:${customerSupportPhone}`}>{customerSupportPhone}</a>
              ) : (
                customerSupportPhone
              )
            }{' '}
            или{NBSP}закажите
            {NBSP}обратный звонок
          </>
        ),
        subtitle: `Ответим на${NBSP}все вопросы с${NBSP}09:00 до${NBSP}18:00 по будням`,
        success: `Заявка принята — перезвоним вам${NBSP}в${NBSP}ближайшее время`,
      }}
    />
  );
};
